"use strict";
import { useMemo } from "react";
export const useRouteCache = (modules) => {
  return useMemo(() => {
    const cache = /* @__PURE__ */ new Map();
    for (const module of modules) {
      const { info, fullscreen } = module;
      const { id } = info;
      cache.set(id, {
        id,
        isFullscreen: fullscreen === true,
        fullscreenPaths: Array.isArray(fullscreen) ? fullscreen : void 0
      });
    }
    return cache;
  }, [modules]);
};
export const extractModuleIdFromPath = (pathname, moduleRootPath) => {
  let normalizedPath = pathname.endsWith("/") && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  if (normalizedPath.startsWith(moduleRootPath)) {
    normalizedPath = normalizedPath.slice(moduleRootPath.length);
  }
  const segments = normalizedPath.split("/").filter(Boolean);
  return segments.length > 0 ? segments[0] : null;
};
export const usePathValidation = (pathname, routeCache, moduleRootPath) => {
  return useMemo(() => {
    const moduleId = extractModuleIdFromPath(pathname, moduleRootPath);
    if (!moduleId) {
      return { isValid: true, moduleId: null };
    }
    const isValid = routeCache.has(moduleId);
    return { isValid, moduleId };
  }, [pathname, routeCache, moduleRootPath]);
};
export const useIsFullscreenRoute = (pathname, routeCache, moduleRootPath) => {
  return useMemo(() => {
    const moduleId = extractModuleIdFromPath(pathname, moduleRootPath);
    if (!moduleId) return false;
    const route = routeCache.get(moduleId);
    if (!route) return false;
    if (route.isFullscreen) return true;
    if (route.fullscreenPaths) {
      const fullPath = pathname.endsWith("/") && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
      return route.fullscreenPaths.some((path) => {
        return fullPath.includes(path);
      });
    }
    return false;
  }, [pathname, routeCache, moduleRootPath]);
};
